import { MotifButton, MotifCard, MotifCardBody, MotifChip, MotifChipGroup, MotifIcon } from '@ey-xd/motif-react';
import { MotifFab } from '@ey-xd/motif-react/components/button';
import React, { useCallback } from 'react'
import iconSvg from "../../assets/icons/icon.svg.json";
import { useDispatch } from 'react-redux';

const ConversationSuccessfullyParsedDocument = (props: any) => {
    const { content, enabledToAnswer } = props;
    const dispatch = useDispatch();
    
    const respondIConfirm = () => {
        dispatch({
            type: "CONVERSATION_MESSAGE_SEND",
            payload: { text: "I confirm" } })
    }
    
    const renderParsedData = useCallback(() => {
        const { parsedData } = content;
        return (
            <div className="py-3">
                {parsedData?.map((option: any, index: number) => {
                    return (
                        <div key={index} className="motif-row w-full mb-1 !ml-0">
                            <div className="motif-col-xs-1 py-2 parsed-document-parsed-data-title bg-[#1A1A24]">
                                <p aria-label={option?.label} className="text-md truncate">{option?.label}</p>
                            </div>
                            <div className="motif-col-xs-3 parsed-document-parsed-data-subtitle py-2" style={{
                                backgroundColor: "rgba(255, 255, 255, 0.05)",
                            }}>
                                <p className="text-lg">{option?.value}</p>
                            </div>
                        </div>
                    )
                })}
                {/* <div className="flex mt-3 justify-center flex-col items-center">
                    <hr className='my-4 w-full' style={{ opacity: "0.1" }} />
                    <div className="absolute cursor-pointer	">
                        <MotifIcon src={iconSvg["add-icon"]} className="" title='add-ico' />
                    </div>
                </div> */}
                <div className="mt-5">
                    <MotifChip
                        disabled={!enabledToAnswer}
                        onClick={respondIConfirm}
                        title="Chip Title"
                    >
                        I confirm that the above context is correct and is good to proceed
                    </MotifChip>
                </div>
            </div>
        )
    }, [enabledToAnswer])
    return (
        <MotifCard className="w-full">
            <MotifCardBody>
                <p className="text-lg font-bold">
                    {content.title}
                </p>
                <p className="text-md">
                    {content.subtitle}
                </p>
                {renderParsedData()}
            </MotifCardBody>
        </MotifCard>
    )
}

export default ConversationSuccessfullyParsedDocument